import React from 'react';
import { Badge, BadgeProps } from '@mantine/core';

export interface ReplacementTagBadgeProps extends BadgeProps {
    children: React.ReactNode;
}

export const ReplacementTagBadge = ({ children, ...others }: ReplacementTagBadgeProps) => {
    return (
        <Badge
            component="span"
            variant="light"
            color="green"
            radius={0}
            size="lg"
            fw={400}
            style={{
                padding: '2px 4px',
                textTransform: 'none',
                cursor: 'default',
                userSelect: 'none',
            }}
            {...others}
        >
            {children}
        </Badge>
    );
};
